import IntentScreen from 'features/onboarding/screens/IntentScreen/IntentScreen';
import React from 'react';

const OnboardingScreen = () => {
  return <IntentScreen />;
};

export default OnboardingScreen;
